<template>
  <div class="login-wrap">
    <div class="header_logo">
        <el-image class="logo" :src="logo" fit="fill">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
        </el-image>
    </div>
    <div class="minddle">
         <div class="formBox">
              <div class="find_text">修改 讯有商城系统 登录初始密码</div>
              <el-form :model="numberruleForm" status-icon :rules="rules" ref="numberruleForm" class="demo-ruleForm">
                   <el-form-item label="" prop="newPass">
                            <el-input placeholder="请输入新密码"  type="password" v-model="numberruleForm.newPass" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="" prop="checkPass">
                      <el-input placeholder="请确认密码"  type="password" v-model="numberruleForm.checkPass" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="submitForm()">修改密码</el-button>
                  </el-form-item>               
              </el-form>
               <div class="textBox">
                 <a class="passtext" @click="$router.push('/login')">我已注册，去登录</a>
                  <el-divider direction="vertical"></el-divider>
                 <a class="creatText" @click="$router.push('/register')">立即注册</a>
              </div>
        </div>
    </div>
    <div class="footer_info">
        <p class="text-center" style="line-height: 30px;">{{informations.copyrightInformation}}<br>
          <a :href="informations.icpUrl" target="_blank">{{informations.icp}}</a>
        </p>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import { resetPassword,setImage,copyRight } from "@/api/xunyou";
import md5 from 'js-md5'
export default {
  name: 'login',
  data() {
    return {
      informations:{},
      logo:"",
      // 第三步
      numberruleForm:{
        newPass:'',
        checkPass:''
      },
      //rules前端验证
      rules: {
        newPass:[{ required: true,
             //  message: "不能为空",
              trigger: ["blur"],
              validator:(rule, value, callback) => {
                 let reg = new RegExp(/^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$)^.{6,16}$/)
                 let result = reg.test(value);
                 if (value == '') {
                     callback(new Error('不能为空'));
                 }else if (!result) {
                     callback(new Error('密码长度6~16位，其中数字，字母和符号至少包含两种'));
                 }else{
                     callback();
                 } 
              }
         }],          
        checkPass:[{ required: true,
                // message: "不能为空",
                 trigger: ["blur"],
                validator:(rule, value, callback) => {
                    let regs = new RegExp(/^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$)^.{6,16}$/)
                    let results = regs.test(value);
                    if (value == '') {
                      callback(new Error('不能为空'));
                    }else if (!results) {
                        callback(new Error('密码长度6~16位，其中数字，字母和符号至少包含两种'));
                    }else if (value != this.numberruleForm.newPass ) {
                      callback(new Error('两次密码不一致'));
                    }else{
                      callback();
                    }
                }
        }], 
      }
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.getImagelogo()
    this.geTCopyright()
  },
  // 里面的函数只有调用才会执行
  methods: {
     // 获取版权名称
    geTCopyright(){
      copyRight().then(res=>{
        console.log(res)
        if(res.code==0){
          this.informations = res.rows[0]
          if(this.informations.powstatus==1){
            this.$router.push('/erroPage')
          }else{
             this.$store.commit('getcopyRight',this.informations)
          }
        }
      }).catch(err=>{
        this.$message.error('查询失败,请稍后再试!')
      })
    },

        // 获取logo
    getImagelogo(){
      setImage().then(res=>{
          if(res.code==0){
            this.logo = res.rows[0].pcLogo
          }
        })
    },
      // 修改密码
       submitForm() {
          this.$refs.numberruleForm.validate(valid => {
              if (valid) {
                const req ={
                  commitpassword:this.numberruleForm.checkPass,
                  newpassword: this.numberruleForm.newPass,
                  uid: this.$route.query.userId,
                }
                 resetPassword(req)
                      .then((res) => {
                          if (res.code == 0) {
                            this.$message({
                                type: 'success',
                                message: '修改成功!'
                            });
                               this.$router.push({ path: '/login' })
                          }else{
                            this.$message.error(res.msg);
                          }
                      })
                      .catch((err) => {
                        this.$message.error("修改失败，请稍后再试！");
                      });                
              }
            })
      },
  }
}
</script>

<style scoped lang='less'>
/deep/ .logo img{
  width: 255px;
  height: 52px;
}
.login-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 100%; 

  .header_logo {
      padding: 30px 140px;
      margin: auto;
  }
  .minddle{
    background: url("~@/assets/img/bigbackground.png") no-repeat;
    position: relative;
    background-repeat: no-repeat;
    background-size: cover;
    height: 530px;
    .formBox {
       width: 450px;
       background: white;
       position: absolute;
       right: 180px;
       top: 120px;
       padding: 40px 50px;
       .codeImgText{
         .el-image.codeImg {
              width: 150px;
              height: 100%;
              cursor: pointer;
          }
          /deep/.el-input-group__append{
            padding: 0;
          }

       }
       .login_text {
         color: #666;
         margin-bottom: 20px;
         color: rgba(151, 152, 152, 0.6);
         font-size: 20px;
      }
      .find_text{
         color: #666;
         margin-bottom: 30px;
         color: rgba(151, 152, 152, 0.6);
         font-size: 20px;
      }
      button.el-button.el-button--primary {
          width: 100%;
          background-color: #394af8;
          border-color: #394af8;
      }
      button.el-button.el-button--primary:hover{
          background-color: #409eff;
          border-color: #409eff;
      }
      .textBox {
          text-align: right;
          font-size: 16px;
          a{
            color: #68b828;
            cursor: pointer;
          }
      }
       .getMessageText {
              display: block;
              // color: white;
              font-size: 16px;
              width: 170px;
              cursor: pointer;
              text-align: center;
          }
          /deep/.el-input-group__append {
             background: #4b5bff;
            color: white;
          }
          /deep/.el-input-group__append:hover {
              background: #5d6bff;
          }

    }
  }
  .footer_info {
    text-align: center;
    font-size: 14px;
    padding: 20px;
    p.text-center {
        color: #979898;
    }
  }
}
.login-container {
  border-radius: 10px;
  margin: 0px auto;
  width: 350px;
  padding: 30px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  text-align: left;
  box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1);
}
.title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
}
.remember {
  margin: 0px 0px 35px 0px;
}
.code-box {
  text-align: right;
}
.codeimg {
  height: 40px;
}
</style>


// WEBPACK FOOTER //
// src/views/initialPasswordSet.vue